import React, { useEffect } from "react";
import Aos from "aos";

const Education = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div class="education" id="education">
      <div className="container">
        <div className="common col-sm-12">
          <h1 className="main-header">My Education</h1>
          <div className="common-border"></div>
        </div>
        <div className="row">
          <div className="col-md-6 col-md-offset-3">
            <ul className="timeline">
              <li>
                <a data-aos="fade-up" className="edu-name">
                  University of Limpopo
                </a>
                <p data-aos="fade-up" className="float-right">
                  2021 - current
                </p>
                <p data-aos="fade-up">
                  <span>Bachelor Science Honours Computer Science.</span>
                  <br />
                  Software engineering, Advanced Databases, Advanced Computer
                  Networks, Computer Security and research on wireless
                  Networking.
                </p>
              </li>
              <li>
                <a className="edu-name">University of Limpopo</a>
                <p data-aos="fade-up" className="float-right ">
                  2018 - 2020
                </p>
                <p data-aos="fade-up">
                  <span>Bachelor Science Mathematical Science.</span>
                  <br />
                  Advanced and applied mathematics, Statistics and Compututer
                  Science. Majored in Computer Science ( Data Structured,
                  Databases, Artificial Intelligence and Computer Networking)
                </p>
              </li>
              <li>
                <a className="edu-name">St Francis Catholic Academy</a>
                <p data-aos="fade-up" className="float-right ">
                  2013 - 2017
                </p>
                <p data-aos="fade-up">
                  <span>NCS Matric</span>
                  <br />
                  Mathematics and Science subjects
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
